module.exports = __webpack_public_path__ + "static/consulting-bg-2ee95cebc6597c69aa362dd3b5d057ec.svg";